<template>
  <div class="container">
    <!-- <p class="titulo-lista-carrito">Total Facturado: ${{ dotsCadaTres(parseFloat(this.totalFacturadoCarrito).toFixed(2).replace(/\.00$/, '')) }}</p>
    <p class="titulo-lista-carrito">Cantidad de productos vendidos: {{ this.cantidadProductosVendidos}}</p> -->
    <!-- <button
      class="boton_exportar"
      @click="exportData"
    >
      Exportar a Excel
    </button> -->
    <table class="tabla-ventas">
      <thead>
        <!-- <th class="nofuente">IMAGEN</th> -->
        <th class="tabla_venta_producto" rowspan="2">Producto</th>
        <th class="tabla_venta_cantidad" rowspan="2">Cantidad vendidos</th>
        <th class="tabla_venta_monto" rowspan="2">Monto Facturado x Producto</th>
        <th class="tabla_venta_desglosado" colspan="4">Desglosado x Producto</th>
        <!-- <th>Condición</th> -->
        <!-- <th class="nofuente gradient_2">Entrega</th> -->
      </thead>
      <tbody>
        <tr>
          <td class="no-cell-info tabla_venta_producto"></td>
          <td class="no-cell-info tabla_venta_cantidad"></td>
          <td class="no-cell-info tabla_venta_monto"></td>
          <td class="no-cell-info tabla_venta_sub_desglosado">Cantidad con Descuento</td>
          <td class="no-cell-info tabla_venta_sub_desglosado">Facturado con Descuento</td>
          <td class="no-cell-info tabla_venta_sub_desglosado">Cantidad sin Descuento</td>
          <td class="no-cell-info tabla_venta_sub_desglosado">Facturado sin Descuento</td>
        </tr>
        <VentasListaCarritoItem
          v-for="venta in ventas"
          :venta="venta"
          :key="venta.venta_id"
        ></VentasListaCarritoItem>
      </tbody>
    </table>
    <table class="tabla-stocks">
      <thead>
        <th>Producto</th>
        <th>Stock</th>
      </thead>
      <tbody>
        <ProductoListaItem
          v-for="producto in productos"
          :producto="producto"
          :key="producto.producto_id"
        ></ProductoListaItem>
      </tbody>
    </table>
<!--     <button
      class="boton_exportar"
      @click="exportData"
    >
      Exportar a Excel
    </button>
    <table class="tabla-stocks">
      <thead>
        <th>Fecha</th>
        <th>Comprador</th>
        <th>Monto</th>
        <th>Mercado Pago Id</th>
        <th>Factura</th>
      </thead>
      <tbody>
        <VentaTotalListaItem
          v-for="ventasTotal in ventasTotales"
          :ventasTotal="ventasTotal"
          :key="ventasTotal.venta_id"
        ></VentaTotalListaItem>
      </tbody>
    </table> -->
  </div>
</template>

<script>
import VentasListaCarritoItem from '../components/VentasListaCarritoItem.vue'
import ProductoListaItem from '../components/ProductoListaItem.vue'
// import VentaTotalListaItem from '../components/VentaTotalListaItem.vue'
import ventasService from '../services/ventas'
import productosService from '../services/productos'
const XLSX = require('xlsx')
export default {
  name: 'VentasListaCarrito',
  components: {
    VentasListaCarritoItem,
    ProductoListaItem
    // VentaTotalListaItem
  },
  data: function () {
    return {
      ventas: [],
      productos: [],
      ventasTotales: [],
      archivo: [],
      cantidadProductosVendidos: null,
      totalFacturadoCarrito: null
    }
  },
  methods: {
    dotsCadaTres (dni) {
      const number = dni.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      return number
    },
    exportData () {
      console.log(this.pagos)
      const data = this.archivo
      // const data = [{ foo: 'foo' }, { bar: 'bar' }]
      // const fileName = 'Listado_de_Pagos'
      // const exportType = 'csv'
      // exportFromJSON({ data, fileName, exportType })
      // exportFromJSON({ data, exportType })
      const workSheet = XLSX.utils.json_to_sheet(data)
      const workBook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workBook, workSheet, 'Ventas Carrito')
      XLSX.writeFile(workBook, 'Ventas_Carrito.xlsx')
    },
    exportarExcel (data) {
      this.archivo = []
      for (var j = 0; j < data.length; j++) {
        const obj = {}
        obj.Producto = data[j].nombre
        obj.Cantidad_Productos_Vendidos = data[j].cantidad
        obj.Total_Facturado = data[j].precio_total
        obj.Cantidad_Productos_Con_Descuento = data[j].cantidad_socio
        obj.Facturado_Productos_Con_Descuento = data[j].facturado_socio
        obj.Cantidad_Productos_Sin_Descuento = data[j].cantidad_no_socio
        obj.Facturado_Productos_Sin_Descuento = data[j].facturado_no_socio
        this.archivo.push(obj)
      }
    }
  },
  mounted: function () {
    ventasService
      .traerProductosVendidos()
      .then(respuesta => {
        // this.cargando = false
        this.cantidadProductosVendidos = respuesta.cantidadProductosVendidos
        this.totalFacturadoCarrito = respuesta.totalFacturadoCarrito
        this.ventas = respuesta.descripcionVentas
        this.ventasTotales = respuesta.ventasTotales
        console.log('Estadistica Carrito: ', respuesta)
        this.exportarExcel(respuesta.descripcionVentas)
      })
    // ventasService
    //   .cantidadProductosVendidos()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.cantidadProductosVendidos = respuesta
    //     console.log('cantidadProductosVendidos: ', respuesta)
    //   })
    // ventasService
    //   .totalFacturadoCarrito()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.totalFacturadoCarrito = respuesta
    //     console.log('totalFacturadoCarrito: ', respuesta)
    //   })
    productosService
      .traerProductosTodos()
      .then(respuesta => {
        // this.cargando = false
        this.productos = respuesta
        console.log('Todos los productos', respuesta)
      })
  }
}
</script>

<style>

</style>
